﻿if (typeof Swiper !== 'undefined') return;

    var BedroomSwiper = new Swiper('.cottage-bedrooms .swiper-container', {
        navigation: {
            prevEl: '.cottage-bedrooms .swiper-nav-prev',
            nextEl: '.cottage-bedrooms  .swiper-nav-next',
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
            },           
            700: {
                slidesPerView: 3
            }            
        }
    });

    if (BedroomSwiper.slides.length <= BedroomSwiper.params.slidesPerView) {
        $('.cottage-bedrooms .swiper-nav').hide();
    }

    $(window).resize(function () {
        if (typeof BedroomSwiper !== 'undefined') {
            if (BedroomSwiper.slides.length <= BedroomSwiper.params.slidesPerView) {
                $('.cottage-bedrooms .swiper-nav').hide();
            } else {
                $('.cottage-bedrooms .swiper-nav').show();
            }
        }
    });


    export var DestinationPageGallery = new Swiper('.destinationGallery .swiper-container', {
        slidesPerView: 1,
        preventClicksPropagation: true,
        preventClicks: false,
        navigation: {
            prevEl: '.destinationGallery .swiper-nav-prev',
            nextEl: '.destinationGallery  .swiper-nav-next',
        },
        loop: true,
        speed: 600,
        preloadImages: false,
        lazy: {
            enabled: true,
            checkInView: true,
            loadPrevNext: true,
            loadPrevNextAmount: 2,
        }
    });

    var locationEvents = new Swiper('.locationEvents .swiper-container', {
        slidesPerView: 1,
        preventClicksPropagation: true,
        preventClicks: false,
        spaceBetween: 100,
        navigation: {
            prevEl: '.locationEvents  .swiper-nav-prev',
            nextEl: '.locationEvents  .swiper-nav-next',
        },
        loop: true,
        speed: 600,
    });

    var PropertySwiper = new Swiper('.cottagePicker .swiper-container', {
        slidesPerView: 1,
        preventClicksPropagation: true,
        preventClicks: false,
        spaceBetween: 20,
        navigation: {
            prevEl: '.cottagePicker  .swiper-nav-prev',
            nextEl: '.cottagePicker  .swiper-nav-next',
        },
        loop: true,
        breakpoints: {
            360: {
                slidesPerView: 2
            },
            760: {
                slidesPerView: 3
            },
            840: {
                slidesPerView: 4
            }
        },
    });
